import { AssessmentResult } from './types'

export function isValid(result: AssessmentResult): boolean {
  return result._tag !== 'Invalid'
}

export function isValidForQuickTender(result: AssessmentResult): boolean {
  return result._tag === 'ValidForQuickTender'
}
